import '../ActivityActions.scss';
import React from 'react';
import { useForm } from 'react-hook-form';
import { ActivityExecutionService } from '@services/actions/ActivityExecutionService';
import ModalContainer, { IModalContainerProps } from '@molecules/ModalContainer/ModalContainer';
import TextareaControl from '@srm/ui/controls/TextareaControl';
import { requiredTextRules } from '@srm/ui/lib/requiredTextRules';
import { stringifyError } from '@srm/core/errors';
import { useActionSubmit } from '@organisms/actions/useActionSubmit';
import { useUnsavedFormInput } from '@srm/ui/hooks/useUnsavedFormInput';
import { ICompleteProps } from './ICompleteProps';

interface ICompleteFormData {
    comment?: string;
}

export const CompleteModal: React.FC<ICompleteProps> = (props: ICompleteProps) => {
    const commentIsRequired = props.commentIsRequired;

    const formMethods = useForm<ICompleteFormData>({ mode: 'onBlur' });
    const hasUnsavedInput = useUnsavedFormInput(formMethods, { textFields: ['comment'] });

    const { errorText, isBusy, isSubmitting, okClick, cancelClick } = useActionSubmit({
        completeHandler: props.completeHandler,
        initialBusy: false,
        resetErrorOnSubmit: true,
        mapError: stringifyError,
        submit: (form: ICompleteFormData) =>
            new ActivityExecutionService().activityComplete(props.actionKey, props.actId, form.comment),
    });

    const modalContainerProps: IModalContainerProps = {
        header: props.displayName,
        size: props.modalSize,
        showOkButton: true,
        showCancelButton: true,
        okButtonText: props.okButtonText,
        cancelButtonText: props.cancelButtonText,
        loading: isBusy,
        closeDisabled: isSubmitting,
        hasUnsavedInput,
        errorText: errorText,
        formMethods: formMethods,
        onSubmit: okClick,
        onCancel: cancelClick,
    };

    return (
        <ModalContainer {...modalContainerProps}>
            <TextareaControl
                name="comment"
                label="Комментарий"
                required={commentIsRequired}
                rows={6}
                control={formMethods.control}
                rules={commentIsRequired ? requiredTextRules() : undefined}
            />
        </ModalContainer>
    );
};
